module.exports = __webpack_public_path__ + "static/media/29DUNON12.c8953053.jpg";